import type { DominanceItem } from "./types";
import { I18nUtil } from "@utils/i18n";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import React from "react";
import { SegmentedBar } from "@/src/components/SegmentedBar";
import Translations from "@translate/components/Home/MarketIndicators/BitcoinDominance/BitcoinDominance";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface BitcoinDominanceProps {
  /** 标题 */
  title?: string;
  /** 数据列表 */
  data?: DominanceItem[];
  /** 自定义类名 */
  className?: string;
}

export const BitcoinDominance: React.FC<BitcoinDominanceProps> = ({
  title = I18n.t("Bitcoin Dominance"),
  data = [],
  className,
}) => {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {/* 标题 */}
      <h3
        aria-label="Bitcoin Dominance h3"
        data-openreplay-label="Bitcoin Dominance h3 Semantic"
        id="sem-bitcoin-dominance-h3"
        className="title_l text-content_primary"
      >
        {title}
      </h3>

      {/* 数据列表 */}
      <div className="flex flex-col gap-1">
        {data.map((item) => (
          <div key={item.name} className="flex items-center justify-between">
            {/* 左侧：币种名称 */}
            <div className="flex items-center gap-1">
              {/* 颜色指示器 */}
              <div
                className="w-1 h-1 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="body_medium_s text-content_primary">
                {item.name}
              </span>
            </div>

            {/* 右侧：百分比和变化 */}
            <div className="flex items-center gap-1">
              <span className="body_bold_m text-content_primary">
                {item.percentage}%
              </span>
              <div
                className={cn(
                  "flex items-center gap-[2px] body_m",
                  item.change >= 0
                    ? "text-content_accent1_primary"
                    : "text-content_accent2_primary",
                )}
              >
                <OspIcons
                  name={item.change >= 0 ? "upvote" : "downvote"}
                  size={12}
                />
                <span className="body_medium_s">{Math.abs(item.change)}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 可视化条形图 */}
      <SegmentedBar
        data={data.map((item) => ({
          id: item.name,
          value: item.percentage,
          color: item.color,
        }))}
        className="mt-1"
      />
    </div>
  );
};
